/**
 * Implement inside submit form:
 * const { isValid, bodyFormData } = validateForm(e.target.elements, this.formFields);
 *
 * if (isValid) {
 *  Send bodyFormData as POST to backend
 * }
 *
 * @param {*} formElements
 * @param {*} fields
 * @returns
 */

export const validateForm = (formElements, fields) => {
  let isValid = true;
  const bodyFormData = new FormData();

  Object.values(formElements).forEach((formElement) => {
    const { name, value, checked, type } = formElement;

    if (name && !fields[name]) {
      console.warn('Achtung: Folgendes Feld wird nicht validiert:', name);
    }

    if (name && fields[name]) {
      bodyFormData.append(name, value);
      if (fields[name].pattern && !fields[name].pattern.value.test(value)) {
        fields[name].error = fields[name].pattern.message;
        isValid = false;
      }

      const hasValue = type === 'checkbox' ? checked : value;
      if (fields[name].required && !hasValue) {
        fields[name].error = fields[name].required;
        isValid = false;
      }
    }
  });

  // console.log(Array.from(bodyFormData.entries()));

  return { isValid, bodyFormData };
};
